export function idsort( a, b ) {
  a = a.match( /[a-zA-Z]+|[0-9]+|[^a-zA-Z0-9]+/gu );
  b = b.match( /[a-zA-Z]+|[0-9]+|[^a-zA-Z0-9]+/gu );
  let res = 0;
  while ( res === 0 ) res = cmp( a.shift(), b.shift() );
  return res;
}

function cmp( a, b ) {
  return a.localeCompare( b, undefined, { numeric : true } );
}
